// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__PzQ2S","image":"styles_image__OjL86","cardBig":"styles_cardBig__p6vZl"};